<cb-lot-spec-colour-item-icons [mappedItem]="mappedItem"></cb-lot-spec-colour-item-icons>
<cb-td-text #codeCol [value]="mappedItem.colourItem.code"></cb-td-text>
<td>{{ mappedItem.colourItem.name }}: {{ mappedItem.name }}</td>
<td #categoryCol>-</td>
<td>Colour</td>
<td #supplierCol>-</td>
<td
    [delayed]="false"
    (cbAfterInit)="
        colWidthSyncService.update(
            mappedItem.id,
            codeCol?.elementRef?.nativeElement,
            categoryCol,
            supplierCol
        )
    "
    (cbOnResize)="
        colWidthSyncService.update(
            mappedItem.id,
            codeCol?.elementRef?.nativeElement,
            categoryCol,
            supplierCol
        )
    "
    (cbOnDestroy)="colWidthSyncService.delete(mappedItem.id)"
    cbTableShrinkCol
    cbTableStickyCol="end"
>
    <button mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_horiz</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
        @if (uiActions.canChangeSpecification()) {
            <button mat-menu-item (click)="uiActions.editColourItem()">Edit</button>
        }
        @if (uiActions.canChangeSpecification()) {
            <button mat-menu-item (click)="uiActions.removeColourItem()">Remove</button>
        }
    </mat-menu>
</td>
